import script from "./pFileItem.vue?vue&type=script&setup=true&lang=js"
export * from "./pFileItem.vue?vue&type=script&setup=true&lang=js"

import "./pFileItem.vue?vue&type=style&index=0&id=6c9f5cd4&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9f5cd4"]])

export default __exports__